/* Decorama online ontwerper – gedeelde code voor productpagina en productiebestand-pagina */
(function () {
  if (window.GlasOntwerper) return;
  var NS = 'http://www.w3.org/2000/svg';

  // naam (zoals in CorelDRAW) | CSS-benadering voor het voorbeeld | extra stijl
  var FONTS = [
    ['Kaufmann', '"DK Kaufmann",Yellowtail,cursive', ''],
    ['Ribbon', '"DK Ribbon","Alex Brush",cursive', ''],
    ['Brush Script', '"DK Brush Script","Brush Script MT","Kaushan Script",cursive', ''],
    ['Zapf Chancery', '"DK Zapf","URW Chancery L","Cormorant Garamond",serif', '|400'],
    ['Klang', '"DK Klang",Merienda,cursive', ''],
    ['Palatino', '"DK Palatino","Palatino Linotype",Palatino,"Libre Baskerville",serif', ''],
    ['Garamond', '"DK Garamond",Garamond,"EB Garamond",serif', '|400'],
    ['Copperplate', '"DK Copperplate",Copperplate,Cinzel,serif', ''],
    ['Ottawa', '"DK Ottawa",Marcellus,serif', ''],
    ['Harrington', '"DK Harrington",Almendra,serif', ''],
    ['Freeform 710', '"DK Freeform","Grenze Gotisch",serif', '|400'],
    ['Cooper Black', '"DK Cooper",Fraunces,serif', ''],
    ['Arial', '"DK Arial",Arial,Helvetica,sans-serif', ''],
    ['Helvetica', 'Helvetica,Inter,Arial,sans-serif', '|500'],
    ['Century Gothic', '"DK Century Gothic","Didact Gothic",sans-serif', ''],
    ['Avantgarde', '"DK Avantgarde",Questrial,sans-serif', ''],
    ['Verdana Bold', '"DK Verdana",Verdana,"PT Sans",sans-serif', '|700'],
    ['Dom Casual', '"DK Dom Casual","Fjalla One",sans-serif', ''],
    ['Parisian', '"DK Parisian","Poiret One",sans-serif', ''],
    ['Impress', '"DK Impress",Fredoka,sans-serif', ''],
    ['Comic Sans', '"DK Comic","Comic Sans MS","Comic Neue",cursive', ''],
    ['Kids', '"DK Kids","Short Stack",cursive', ''],
    ['Agency FB', '"DK Agency","Agency FB",Oswald,sans-serif', '|400'],
    ['Bickley Script LET', '"DK Bickley","Bickley Script LET","Great Vibes",cursive', ''],
    ['Freehand521 BT', '"DK Freehand","Freehand521 BT",Courgette,cursive', ''],
    ['Balqis', '"DK Balqis",Balqis,Parisienne,cursive', ''],
    ['Bluemoon', '"DK Bluemoon",Bluemoon,Allura,cursive', ''],
    ['Calibri', '"DK Calibri",Calibri,Carlito,sans-serif', ''],
    ['Sweet Hipster', '"DK Sweet Hipster","Sweet Hipster","Dancing Script",cursive', '|400'],
    ['Strawberry Blossom', '"DK Strawberry","Strawberry Blossom",Satisfy,cursive', ''],
    ['Marnie', '"DK Marnie",Marnie,Sacramento,cursive', ''],
    ['Segoe Print', '"DK Segoe Print","Segoe Print","Patrick Hand",cursive', ''],
    ['Amazone BT', '"DK Amazone","Amazone BT","Pinyon Script",cursive', ''],
    ['BakerSignet', '"DK Baker Signet",BakerSignet,"Cormorant Upright",serif', '|400'],
    ['Times New Roman', '"DK Times","Times New Roman",Tinos,serif', ''],
    ['Beyond The Mountains', '"DK Beyond","Beyond The Mountains",Damion,cursive', ''],
    ['VanDijk', '"DK VanDijk",VanDijkDEE,Handlee,cursive', ''],
    ['Futura', '"DK Futura",Jost,sans-serif', '|400'],
    ['Roundhand', '"DK Roundhand R","Pinyon Script",cursive', '|400'],
    ['Futura Bk BT', '"DK Futura",Jost,sans-serif', 'italic|400'],
    ['Balloon', '"DK Balloon","Balloon Lt BT","Gochi Hand",cursive', ''],
    ['Heineken', '"DK Heineken",Heineken,"Alfa Slab One",serif', ''],
    ['Almonte Snow', '"DK Almonte","Almonte Snow","Mountains of Christmas",cursive', '|400'],
    ['Snowdrift', '"DK Snowdrift",Snowdrift,"Mountains of Christmas",cursive', '|400'],
    ['Merry Christmas Star', '"DK Merry Star","Merry Christmas Star","Dancing Script",cursive', '|400'],
    ['Augustus', '"DK Augustus",Augustus,Cinzel,serif', ''],
    ['Janda Stylish Script', '"DK Janda","Janda Stylish Script",Sacramento,cursive', ''],
    ['Sverige Script', '"Sverige Script Demo",Allura,cursive', ''],
    ['Sweet Pea', '"DK Sweet Pea","Sweet Pea","Lobster Two",cursive', ''],
    ['Verdana', '"DK Verdana",Verdana,sans-serif', ''],
    ['Arial Black', '"DK Arial Black","Arial Black","Archivo Black",sans-serif', '|900'],
    ['Comfortaa', 'Comfortaa,sans-serif', ''],
    ['Roland', '"DK Roland",Roland,"Kaushan Script",cursive', ''],
    ['BlackJack', '"DK BlackJack",BlackJack,"Kaushan Script",cursive', ''],
    ['Bookman Old Style', '"DK Bookman","Bookman Old Style","Libre Baskerville",serif', ''],
    ['Hollywood Hills', '"DK Hollywood Hills","Hollywood Hills","Archivo Black",sans-serif', '|400'],
    ['Windsor El BT', '"DK Windsor","Windsor El BT",Oswald,sans-serif', ''],
    ['GoodVibrationsROB', '"DK GoodVibrations",GoodVibrationsROB,"Great Vibes",cursive', ''],
    ['Bernard MT Condensed', '"DK Bernard","Bernard MT Condensed","Fjalla One",sans-serif', ''],
    ['Copperplate Gothic Bold', '"DK Copperplate",Cinzel,serif', ''],
    ['Birch', '"DK Birch","Birch Std",Oswald,sans-serif', ''],
    ['Desert Queen', '"Desert Queen","Kaushan Script",cursive', ''],
    ['Old English', '"DK Old English","Old English Text MT","Grenze Gotisch",serif', '|400'],
    ['Thirsty Script', '"DK Thirsty","Thirsty Script",Damion,cursive', ''],
    ['AR Cena', '"DK AR Cena","AR CENA","Fjalla One",sans-serif', ''],
    ['Vladimir Script', '"DK Vladimir","Vladimir Script","Pinyon Script",cursive', ''],
    ['Binner', '"DK Binner",BinnerDEE,"Fjalla One",sans-serif', ''],
    ['Stackyard', 'Stackyard,"Kaushan Script",cursive', ''],
    ['Bolt', '"DK Bolt","Bolt Bd BT","Archivo Black",sans-serif', '|400'],
    ['Aachen', '"DK Aachen","Aachen BT","Alfa Slab One",serif', ''],
    ['Univers Black', '"DK Univers XB","Univers ExtraBlack","Archivo Black",sans-serif', '|400'],
    ['Bobcat', '"DK Bobcat",Bobcat,"Gochi Hand",cursive', ''],
    ['Goudy Old Style', '"DK Goudy","Goudy Old Style","Sorts Mill Goudy",serif', ''],
    ['Brush Script', '"Brush Script MT",Damion,cursive', ''],
    ['Freeform 710', '"Freefrm710 BT","Kaushan Script",cursive', ''],
    ['Exotic 350', '"DK Exotic 350","Exotc350 Bd BT",Cinzel,serif', '|400'],
    ['Courgette', 'Courgette,cursive', ''],
    ['Brush 455', '"DK Brush 455","Brush455 BT",Yellowtail,cursive', ''],
    ['Adamina', 'Adamina,"Libre Baskerville",serif', ''],
    ['Adelle', '"DK Adelle","Adelle Rg","Roboto Slab",serif', ''],
    ['Ferro Rosso', '"DK Ferro Rosso","Ferro Rosso","Lobster Two",cursive', ''],
    ['VAG Rounded', '"DK VAG Rounded","VAGRounded BT","VAG Rounded","Varela Round",sans-serif', ''],
    ['Asimov', '"DK Asimov",Asimov,Orbitron,sans-serif', ''],
    ['Vintage Party', '"Vintage Party FreeVersion",Yellowtail,cursive', ''],
    ['Antara', '"DK Antara","a Antara Distance","Great Vibes",cursive', ''],
    ['Gabriola', '"DK Gabriola",Gabriola,"Cormorant Upright",serif', '|400'],
    ['Architects Daughter', '"Architects Daughter",cursive', ''],
    ['Candy Round', '"DK Candy Round","Candy Round BTN",Fredoka,sans-serif', '|400'],
    ['Vivaldi', '"DK Vivaldi",Vivaldi,"Pinyon Script",cursive', ''],
    ['Sabatons Script', '"Sabatons Script DEMO","Kaushan Script",cursive', ''],
    ['AR Blanca', '"DK AR Blanca","AR BLANCA","Gochi Hand",cursive', ''],
    ['Great Vibes', '"Great Vibes",cursive', ''],
    ['Libre Baskerville', '"Libre Baskerville",serif', '|700'],
    ['Oswald', 'Oswald,sans-serif', '|700'],
    ['Yellowtail', 'Yellowtail,cursive', ''],
    ['Anjelika Rose', '"DK Anjelika Rose","Anjelika Rose","Patrick Hand",cursive', ''],
    ['BlacklightD', '"DK BlacklightD",BlacklightD,"Gochi Hand",cursive', ''],
    ['Bauhaus', '"DK Bauhaus","Bauhaus Md BT",Comfortaa,sans-serif', '|400'],
    ['Playball', 'Playball,cursive', ''],
    ['Balloon Bold', '"DK Balloon Bold","Balloon Bd BT","Gochi Hand",cursive', '|400'],
    ['Segoe UI', '"DK Segoe UI","Segoe UI",Inter,sans-serif', '|600'],
    ['Brandon Grotesque Black', '"DK Brandon Black","Brandon Grotesque Black","Josefin Sans",sans-serif', '|400'],
    ['Brandon Grotesque', '"Brandon Grotesque Bold","Josefin Sans",sans-serif', '|700'],
    ['Cabin', 'Cabin,sans-serif', 'italic|400'],
    ['Keep Calm', '"DK Keep Calm","Keep Calm Med",Montserrat,sans-serif', '|400'],
    ['Arial BI', '"DK Arial",Arial,Arimo,"Liberation Sans",sans-serif', 'italic|700'],
    ['Roska', '"DK Roska",Jost,sans-serif', '|400'],
    ['Dakota', '"DK Dakota",Dakota,Handlee,cursive', '']
  ];
  function fontInfo(name) {
    for (var i = 0; i < FONTS.length; i++) if (FONTS[i][0] === name) {
      var ex = (FONTS[i][2] || '|').split('|');
      return { name: name, css: FONTS[i][1], style: ex[0] || 'normal', weight: ex[1] || '400' };
    }
    return { name: name || 'Kaufmann', css: 'Yellowtail,cursive', style: 'normal', weight: '400' };
  }

  var clipCache = {};
  function loadClip(url) {
    if (!clipCache[url]) clipCache[url] = fetch(url).then(function (r) { return r.text(); }).then(function (t) {
      var vb = (/viewBox="([^"]+)"/.exec(t) || [0, '0 0 100 100'])[1].split(/[\s,]+/).map(Number);
      var inner = t.replace(/^[\s\S]*?<svg[^>]*>/, '').replace(/<\/svg>\s*$/, '');
      return { vb: vb, inner: inner };
    });
    return clipCache[url];
  }

  function el(name, attrs) { var e = document.createElementNS(NS, name); for (var k in attrs) e.setAttribute(k, attrs[k]); return e; }

  // meet tekstbreedte per font-size 1 in het doel-svg
  function measure(svg, text, f) {
    var t = el('text', { x: 0, y: 0, 'font-size': 10, 'font-family': f.css, 'font-style': f.style, 'font-weight': f.weight, style: 'visibility:hidden' });
    t.textContent = text; svg.appendChild(t);
    var w = 0; try { w = t.getComputedTextLength(); } catch (e) {}
    if (!w) w = text.length * 5.5;
    svg.removeChild(t); return w / 10;
  }

  // grootte-keuzes (index 0..3), factor t.o.v. "vol" graveervlak
  var SIZES = [['Klein', 0.6], ['Normaal', 0.8], ['Groot', 1.0], ['Extra groot', 1.2]];
  function sizeF(s, i) { var k = s && s[i] != null ? s[i] : 1; return (SIZES[k] || SIZES[1])[1]; }

  function group(parent, key) { var g = el('g', { 'data-el': key }); parent.appendChild(g); return g; }

  // verschuiving (mm) begrenzen zodat het element binnen het graveervlak blijft
  function clampOffset(g, dx, dy, W, H) {
    var b; try { b = g.getBBox(); } catch (e) { return [dx, dy]; }
    var px = 0, py = 0, p = g.parentNode;
    if (p && p.getAttribute && p.getAttribute('data-el')) {
      var m = /translate\(([-\d.]+),([-\d.]+)\)/.exec(p.getAttribute('transform') || '');
      if (m) { px = +m[1]; py = +m[2]; }
    }
    var x0 = b.x + px, y0 = b.y + py;
    var minX = -x0, maxX = W - x0 - b.width, minY = -y0, maxY = H - y0 - b.height;
    if (maxX < minX) { minX = maxX = (minX + maxX) / 2; }
    if (maxY < minY) { minY = maxY = (minY + maxY) / 2; }
    return [Math.round(Math.min(maxX, Math.max(minX, dx)) * 10) / 10, Math.round(Math.min(maxY, Math.max(minY, dy)) * 10) / 10];
  }
  function applyOffset(g, o, W, H) {
    if (!g || !o || (!o[0] && !o[1])) return;
    var c = clampOffset(g, o[0], o[1], W, H);
    g.setAttribute('transform', 'translate(' + c[0] + ',' + c[1] + ')');
  }

  function addText(svg, text, f, cx, cy, maxW, maxH, mode, fill) {
    if (!text) return;
    var perUnit = measure(svg, text, f);
    var fs = Math.min(maxH / 0.95, maxW / perUnit);
    var t = el('text', {
      x: cx.toFixed(2), y: (cy + fs * 0.32).toFixed(2), 'text-anchor': 'middle',
      'font-size': fs.toFixed(2),
      'font-family': f.css, 'font-style': f.style, 'font-weight': f.weight,
      'data-font': f.name,
      fill: fill
    });
    t.textContent = text; svg.appendChild(t);
  }

  function addClip(svg, c, x, y, w, h, fill) {
    var vb = c.vb, sc = Math.min(w / vb[2], h / vb[3]);
    var ox = x + (w - vb[2] * sc) / 2 - vb[0] * sc, oy = y + (h - vb[3] * sc) / 2 - vb[1] * sc;
    var g = el('g', { transform: 'translate(' + ox.toFixed(3) + ',' + oy.toFixed(3) + ') scale(' + sc.toFixed(6) + ')', fill: fill, color: fill });
    g.innerHTML = c.inner; svg.appendChild(g);
  }

  // eigen logo van de klant: voorbeeld als gravure (donkere delen worden 'gegraveerd'), in het productiebestand een kader met plek en maat
  function addLogo(g, meta, x, y, w, h, mode, fill) {
    var root = g.ownerSVGElement || g;
    if (meta.url && mode !== 'prod') {
      var fid = 'go-logo-f';
      if (!root.querySelector('#' + fid)) {
        var c = /rgba?\(([^)]+)\)/.exec(fill || ''), rgb = [1, 1, 1], a = 0.9;
        if (c) { var v = c[1].split(',').map(parseFloat); rgb = [v[0] / 255, v[1] / 255, v[2] / 255]; if (v[3] != null) a = v[3]; }
        var defs = el('defs', {}), f = el('filter', { id: fid, 'color-interpolation-filters': 'sRGB', x: '0', y: '0', width: '1', height: '1' });
        f.appendChild(el('feColorMatrix', { type: 'matrix', values: '0 0 0 0 ' + rgb[0].toFixed(3) + ' 0 0 0 0 ' + rgb[1].toFixed(3) + ' 0 0 0 0 ' + rgb[2].toFixed(3) + ' ' + (-0.2126 * a).toFixed(4) + ' ' + (-0.7152 * a).toFixed(4) + ' ' + (-0.0722 * a).toFixed(4) + ' 0 ' + a, result: 'm' }));
        f.appendChild(el('feComposite', { in: 'm', in2: 'SourceAlpha', operator: 'in' }));
        defs.appendChild(f); root.insertBefore(defs, root.firstChild);
      }
      var im = el('image', { x: x.toFixed(3), y: y.toFixed(3), width: w.toFixed(3), height: h.toFixed(3), preserveAspectRatio: 'xMidYMid meet', filter: 'url(#' + fid + ')' });
      im.setAttribute('href', meta.url); g.appendChild(im);
    } else {
      g.appendChild(el('rect', { x: x.toFixed(3), y: y.toFixed(3), width: w.toFixed(3), height: h.toFixed(3), fill: 'none', stroke: mode === 'prod' ? '#ff0000' : fill, 'stroke-width': '0.4', 'stroke-dasharray': '2 1.2' }));
      var t = el('text', { x: (x + w / 2).toFixed(3), y: (y + h / 2).toFixed(3), 'text-anchor': 'middle', 'dominant-baseline': 'central', 'font-family': 'Arial', 'font-size': Math.max(2, Math.min(h * 0.18, w * 0.12)).toFixed(2), fill: mode === 'prod' ? '#ff0000' : fill });
      t.textContent = 'LOGO ' + Math.round(w) + ' x ' + Math.round(h) + ' mm'; g.appendChild(t);
    }
  }

  /*
    d   = { t1, t2, f, c }   (tekst boven, tekst onder, lettertype, afbeelding-id)
    cfg = { W, H (mm), clips: { id: { url, ratio, kader } } }
    mode: 'preview' (wit/mat op glas) of 'prod' (zwart, echte lettertypenamen)
  */
  /*
    d.s = [grootte tekst boven, afbeelding, tekst onder] als index in SIZES (standaard 1 = Normaal)
    d.o = { a: [dx,dy], c: [dx,dy], b: [dx,dy] } verschuiving in mm (a = tekst boven, c = afbeelding, b = tekst onder)
  */
  /* vaste ontwerpen (bijv. MD9): assets/ontwerp-<id>.json met { vb, art, lines:[{t,f,font,x,y,fs,sx,p,b}], fixed }
     d.tpl = id, d.L = tekst per regel (leeg = regel weglaten), d.s[1] = grootte, d.o.c = verschuiving */
  var tplCache = {};
  var TPL_SIZES = [0.55, 0.7, 0.85, 1.0];
  // grootte per regel (d.ls[i]): Kleiner / Normaal / Groter / Extra groot
  // index 0-3 blijven gelijk (bestaande bestellingen); 4 en 5 = kleinere stappen, in de keuzelijst van klein naar groot
  var LINE_SIZES = [['Kleiner', 0.8], ['Normaal', 1], ['Groter', 1.2], ['Extra groot', 1.4], ['Heel klein', 0.45], ['Klein', 0.6]];
  var LS_ORDER = [4, 5, 0, 1, 2, 3];
  Object.defineProperty(LINE_SIZES, 'forEach', { value: function (cb, ctx) { var a = this; LS_ORDER.forEach(function (i) { cb.call(ctx, a[i], i, a); }); } });
  function tplUrl(cfg, id) {
    if (cfg.tpls && cfg.tpls[id]) return cfg.tpls[id];
    var el = document.querySelector('[data-go-tpls]'), m = {};
    try { m = JSON.parse(el.textContent); } catch (e) {}
    cfg.tpls = m; return m[id];
  }
  function loadTpl(url) {
    if (!tplCache[url]) tplCache[url] = fetch(url).then(function (r) { return r.json(); });
    return tplCache[url];
  }
  // beginletter van een naam (Ö -> O, IJ -> I); geen letter bij een cijfer of teken
  function initialOf(s) {
    s = String(s || '').trim(); if (!s) return '';
    var c = (s.normalize ? s.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : s).charAt(0).toUpperCase();
    return /[A-Z]/.test(c) ? c : '';
  }
  // sterrenbeeld uit een datum (bijv. 12-08, 12 augustus, 12.8.1990)
  var MAANDEN = ['jan', 'feb', 'maa', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  var TEKENS = [['Steenbok', 19], ['Waterman', 18], ['Vissen', 20], ['Ram', 19], ['Stier', 20], ['Tweelingen', 20], ['Kreeft', 22], ['Leeuw', 22], ['Maagd', 22], ['Weegschaal', 22], ['Schorpioen', 21], ['Boogschutter', 21]];
  function zodiacOf(s) {
    var m = /(\d{1,2})\s*[-.\/ ]\s*(\d{1,2}|[a-zA-Z]+)/.exec(String(s || '')); if (!m) return '';
    var dag = +m[1], mnd = /^\d+$/.test(m[2]) ? +m[2] - 1 : MAANDEN.indexOf(m[2].toLowerCase().replace('mrt', 'maa').slice(0, 3));
    if (mnd < 0 || mnd > 11 || dag < 1 || dag > 31) return '';
    return dag <= TEKENS[mnd][1] ? TEKENS[mnd][0] : TEKENS[(mnd + 1) % 12][0];
  }
  // afgeleide regels: geen eigen invoerveld, tekst volgt uit een andere regel
  var MAANDNAAM = ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'];
  function monthOf(s) {
    var m = /(\d{1,2})\s*[-.\/ ]\s*(\d{1,2}|[a-zA-Z]+)/.exec(String(s || '')); if (!m) return -1;
    var mnd = /^\d+$/.test(m[2]) ? +m[2] - 1 : MAANDEN.indexOf(m[2].toLowerCase().replace('mrt', 'maa').slice(0, 3));
    return mnd >= 0 && mnd < 12 ? mnd : -1;
  }
  function isDerived(L) { return L.ini != null || L.zod != null || L.age != null || L.mon != null; }
  // regels met een vast lettertype (klantkeuze 'tf' geldt er niet voor)
  function keepFont(L) { return L.ini != null || L.zod != null || L.mon != null; }
  function deriveTexts(tpl, t) {
    var jaar = new Date().getFullYear();
    tpl.lines.forEach(function (L, i) {
      // L.ini = j: beginletter van regel j (grote initiaal achter de naam)
      if (L.ini != null) t[i] = initialOf(t[L.ini]);
      // L.zod = j: sterrenbeeld bij de datum in regel j (naam, of tekening via L.opts)
      if (L.zod != null) { var z = zodiacOf(t[L.zod]); t[i] = z ? (L.uc ? z.toUpperCase() : z) : ''; }
      // L.age = j: leeftijd uit het geboortejaar in regel j
      // L.mon = j: maand uit de datum in regel j (tekening via L.opts per maand, of tekst uit L.vals per maand)
      if (L.mon != null) { var mi = monthOf(t[L.mon]); var mt2 = mi < 0 ? '' : (L.vals ? L.vals[mi] : MAANDNAAM[mi]); t[i] = L.uc ? mt2.toUpperCase() : mt2; }
      if (L.age != null) { var y = parseInt(t[L.age], 10); t[i] = y > 1900 && y <= jaar ? String(jaar - y) : ''; }
    });
    return t;
  }
  function tplTexts(tpl, d) {
    var t = tpl.lines.map(function (L, i) { return d.L && d.L[i] != null ? String(d.L[i]).trim() : L.t; });
    return deriveTexts(tpl, t);
  }
  async function renderTpl(svg, d, cfg, mode, fill, tok) {
    var W = cfg.W, H = cfg.H, url = tplUrl(cfg, d.tpl);
    var tpl = url ? await loadTpl(url) : null;
    if (!tpl) return;
    var texts = tplTexts(tpl, d);
    if (mode !== 'prod' && document.fonts && document.fonts.load) {
      for (var i = 0; i < tpl.lines.length; i++) if (texts[i] && !tpl.lines[i].fix && !tpl.lines[i].clock && (texts[i] !== tpl.lines[i].t || d.tf || (d.ls && d.ls[i] != null && d.ls[i] !== 1))) {
        var fi = fontInfo(d.tf && !keepFont(tpl.lines[i]) ? d.tf : tpl.lines[i].f);
        if (tpl.lines[i].wt && !(d.tf && !keepFont(tpl.lines[i]))) fi.weight = String(tpl.lines[i].wt);
        try { await document.fonts.load(fi.style + ' ' + fi.weight + ' 20px ' + fi.css, texts[i]); } catch (e) {}
      }
    }
    if (svg._goTok !== tok) return;
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    var vb = tpl.vb, si = d.s && d.s[1] != null ? d.s[1] : 2;
    var k = Math.min(W / vb[2], H / vb[3]) * (TPL_SIZES[si] || TPL_SIZES[2]);
    var ox = (W - vb[2] * k) / 2 - vb[0] * k, oy = (H - vb[3] * k) / 2 - vb[1] * k;
    var gC = group(svg, 'c');
    var g = el('g', { transform: 'translate(' + ox.toFixed(3) + ',' + oy.toFixed(3) + ') scale(' + k.toFixed(6) + ')', fill: fill, color: fill });
    gC.appendChild(g);
    var art = el('g', { 'fill-rule': 'evenodd' }); art.innerHTML = tpl.art; g.appendChild(art);
    // los verschuifbare regels (naamborden, cfg.los): elke regel een eigen groep data-el="l<i>"; ook als het ontwerp al zulke verschuivingen bevat
    var sep = !!(cfg.los || (d.o && Object.keys(d.o).some(function (k) { return /^l\d+$/.test(k); }))), lineGs = [];
    function lineHost(i) {
      var lg = group(svg, 'l' + i), inner = el('g', { transform: g.getAttribute('transform'), fill: fill, color: fill });
      lg.appendChild(inner); lineGs.push([lg, i]); return inner;
    }
    // uitgespaarde delen (wit in het ontwerp): in het voorbeeld via een masker, in productie wit
    var mask = null, kos = art.querySelectorAll('[data-ko]');
    var hasKo = kos.length || tpl.lines.some(function (L) { return L.ko || L.h; });
    if (hasKo && mode !== 'prod') {
      var mid = 'gom' + Math.random().toString(36).slice(2, 8);
      var defs = el('defs', {}); mask = el('mask', { id: mid, maskUnits: 'userSpaceOnUse', x: vb[0], y: vb[1], width: vb[2], height: vb[3] });
      mask.appendChild(el('rect', { x: vb[0], y: vb[1], width: vb[2], height: vb[3], fill: '#fff' }));
      defs.appendChild(mask); g.insertBefore(defs, art);
      art.setAttribute('mask', 'url(#' + mid + ')');
      kos.forEach(function (p) { p.setAttribute('fill', '#000'); mask.appendChild(p); });
    } else if (hasKo) {
      kos.forEach(function (p) { p.setAttribute('fill', '#ffffff'); art.appendChild(p); });
    }
    // vrijruimte (halo) rond tekst: kopie met dikke rand in het masker (voorbeeld) of wit (productie)
    function addLine(L, node, host) {
      if (L.h) {
        var sc = L.m && node.tagName === 'text' ? Math.sqrt(L.m[0] * L.m[0] + L.m[1] * L.m[1]) : 1;
        var halo = node.cloneNode(true), hc = mask ? '#000' : '#ffffff';
        halo.setAttribute('fill', hc); halo.setAttribute('stroke', hc); halo.setAttribute('stroke-width', (L.h / sc).toFixed(2)); halo.setAttribute('stroke-linejoin', 'round');
        if (mask) mask.appendChild(halo); else g.appendChild(halo);
      }
      // L.u: regel ligt onder uitgespaarde vlakken (bv. witte band over een grote initiaal)
      if (host === art) art.insertBefore(node, art.querySelector('[data-ko]')); else host.appendChild(node);
    }
    var koLines = [];
    tpl.lines.forEach(function (L, i) {
      // L.clock: wijzers van een klok op de ingevulde tijd zetten (bijv. 14:32)
      if (L.clock) {
        var C = L.clock, tm = /^\s*(\d{1,2})\s*(?:[:.uh ]\s*(\d{1,2}))?/i.exec(texts[i] || L.t || '') || [0, 7, 0];
        var hh = Math.min(23, +tm[1] || 0), mi = Math.min(59, +(tm[2] || 0));
        if (C.R) {
          // getekende wijzers (omlijnd): kapsules + naaf, eerst alle randen, dan alle vullingen
          var ah2 = (hh % 12) * 30 + mi * 0.5, am2 = mi * 6, sw2 = C.sw * 2;
          var shapes = function (fl, st) {
            var o = [[ah2, C.hl], [am2, C.ml]].map(function (p) {
              return el('rect', { x: (C.cx - C.w / 2).toFixed(2), y: (C.cy - p[1]).toFixed(2), width: C.w, height: p[1], rx: C.w / 2, transform: 'rotate(' + p[0].toFixed(2) + ' ' + C.cx + ' ' + C.cy + ')', fill: fl, stroke: st, 'stroke-width': sw2 });
            });
            o.push(el('circle', { cx: C.cx, cy: C.cy, r: C.R, fill: fl, stroke: st, 'stroke-width': sw2 }));
            return o;
          };
          if (mode === 'prod') { shapes('none', fill).concat(shapes('#ffffff', 'none')).forEach(function (s) { g.appendChild(s); }); return; }
          var ext = C.ml + C.w + sw2, mid = 'gck' + Math.random().toString(36).slice(2, 8);
          var mk = el('mask', { id: mid, maskUnits: 'userSpaceOnUse', x: C.cx - ext, y: C.cy - ext, width: 2 * ext, height: 2 * ext });
          shapes('none', '#fff').concat(shapes('#000', 'none')).forEach(function (s) { mk.appendChild(s); });
          g.appendChild(mk);
          g.appendChild(el('rect', { x: C.cx - ext, y: C.cy - ext, width: 2 * ext, height: 2 * ext, fill: fill, mask: 'url(#' + mid + ')' }));
          return;
        }
        var ah = ((hh % 12) * 30 + mi * 0.5) - C.ha, am = mi * 6 - C.ma;
        g.appendChild(el('path', { d: C.h, transform: 'rotate(' + ah.toFixed(2) + ' ' + C.cx + ' ' + C.cy + ')' }));
        g.appendChild(el('path', { d: C.m, transform: 'rotate(' + am.toFixed(2) + ' ' + C.cx + ' ' + C.cy + ')' }));
        return;
      }
      var txt = L.fix ? L.t : texts[i]; if (!txt) return;
      // d.tf = door de klant gekozen lettertype voor alle aanpasbare regels
      var own = !!(d.tf && !L.fix && !keepFont(L));
      var lsf = d.ls && d.ls[i] != null && LINE_SIZES[d.ls[i]] ? LINE_SIZES[d.ls[i]][1] : 1;
      var same = txt === L.t && !own && lsf === 1;
      // L.uc: lettertype met alleen hoofdletters (bijv. ROSKA): ingevulde tekst in hoofdletters tonen
      if (L.uc && !same && !own) txt = txt.toUpperCase();
      var host = L.ko && mask ? mask : (L.u ? art : g);
      if (sep && host === g && !L.h) host = lineHost(i);
      var col = L.ko ? (mask ? '#000' : '#ffffff') : (L.col && mode !== 'prod' ? L.col : fill);
      // L.kr: uitsparing die bij deze regel hoort (schuift mee); in productie wit, in het voorbeeld een masker op regels met L.km
      if (L.kr) { koLines.push(i); if (mode === 'prod') host.appendChild(el('path', { d: L.kr, fill: '#ffffff' })); }
      // L.bar: vaste versiering die bij deze regel hoort en mee verschuift (bijv. twee strepen rond een datum)
      if (L.bar) { var bg = el('g', {}); bg.innerHTML = L.bar; host.appendChild(bg); }
      // L.opts: tekening per uitkomst (bijv. sterrenbeeld-symbool), getekend als vorm
      if (L.opts) { var op = L.opts[txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase()]; if (op) addLine(L, el('path', { d: op, fill: col }), host); return; }
      if (same && mode !== 'prod') { addLine(L, el('path', { d: L.p, fill: col }), host); return; }
      var fi = fontInfo(own ? d.tf : L.f), t;
      // L.wt: afwijkend gewicht voor deze regel (bijv. 700 = vet)
      if (L.wt && !own) fi = { name: fi.name, css: fi.css, style: fi.style, weight: String(L.wt) };
      var pf = own ? d.tf : L.font;
      if (L.arc) {
        // tekst op een cirkelboog (zoals CorelDRAW: losse letters, elk gedraaid); leesrichting tegen de klok in, letters met de kop naar het midden
        var A = L.arc, chars = txt.split(''), ws = chars.map(function (c) { return measure(svg, c === ' ' ? '\u00a0' : c, fi); });
        var tot = ws.reduce(function (a, b) { return a + b; }, 0) || 1;
        var fsA = Math.min(A.fs * lsf, (A.r * A.max * Math.PI / 180) / tot), s0 = 0, ga = el('g', {});
        chars.forEach(function (c, j) {
          var sc = s0 + ws[j] * fsA / 2; s0 += ws[j] * fsA; if (c === ' ') return;
          var th = A.a * Math.PI / 180 + (tot * fsA / 2 - sc) / A.r, px = A.cx + A.r * Math.cos(th), py = A.cy + A.r * Math.sin(th);
          var tc = el('text', { x: px.toFixed(1), y: py.toFixed(1), 'text-anchor': 'middle', 'font-size': fsA.toFixed(1), 'font-family': mode === 'prod' ? pf : fi.css, 'font-style': fi.style, 'font-weight': fi.weight, 'data-font': pf, fill: col, transform: 'rotate(' + (th * 180 / Math.PI - 90).toFixed(2) + ' ' + px.toFixed(1) + ' ' + py.toFixed(1) + ')' });
          tc.textContent = c; ga.appendChild(tc);
        });
        addLine(L, ga, host); return;
      }
      if (L.m) {
        // nieuw formaat: lokale tekstcoordinaten + matrix (ook gedraaide tekst)
        var mt = 'matrix(' + L.m.join(',') + ')';
        if (same) {
          var q1 = L.fs > 4000 ? L.fs / 1000 : 1;
          t = el('text', { x: (L.x / q1).toFixed(2), y: (L.y / q1).toFixed(2), 'font-size': (L.fs / q1).toFixed(2), 'font-family': L.font, 'data-font': L.font, fill: col, transform: mt + (q1 !== 1 ? ' scale(' + q1.toFixed(4) + ')' : '') });
        } else {
          // mw = maximale breedte (lokale eenheden) zodat lange tekst binnen het vlak blijft; cx = optioneel midden; vc = kleinere tekst iets omhoog
          var per2 = measure(svg, txt, fi), fs2 = Math.min(L.fs * lsf, (L.mw || Math.max(L.w * 1.35, L.fs * 2)) * lsf / per2);
          var ty2 = L.vc ? L.y - Math.max(0, L.fs - fs2) * L.vc : L.y;
          var anc = L.al === 's' ? 'start' : (L.al === 'e' ? 'end' : 'middle'), axx = L.al === 's' ? L.x : (L.al === 'e' ? L.x + L.w : (L.cx != null ? L.cx : L.x + L.w / 2));
          // browsers kappen font-size rond 10000: grote waarden via een extra schaal tekenen
          var q2 = fs2 > 4000 ? fs2 / 1000 : 1;
          t = el('text', { x: (axx / q2).toFixed(2), y: (ty2 / q2).toFixed(2), 'text-anchor': anc, 'font-size': (fs2 / q2).toFixed(2), 'font-family': mode === 'prod' ? pf : fi.css, 'font-style': fi.style, 'font-weight': fi.weight, 'data-font': pf, fill: col, transform: mt + (q2 !== 1 ? ' scale(' + q2.toFixed(4) + ')' : '') });
        }
        t.textContent = txt; addLine(L, t, host); return;
      }
      if (same) {
        // productie: precies zoals in het originele ontwerp, met het echte lettertype
        t = el('text', { x: L.x, y: L.y, 'font-size': L.fs, 'font-family': L.font, 'data-font': L.font, fill: fill });
        if (L.sx && Math.abs(L.sx - 1) > 0.001) t.setAttribute('transform', 'translate(' + L.x + ',0) scale(' + L.sx + ',1) translate(' + (-L.x) + ',0)');
      } else {
        var b = L.b, cx = b[0] + b[2] / 2;
        var maxW = Math.min(vb[2] * 0.96, Math.max(b[2] * 1.35, b[3] * 2));
        var per = measure(svg, txt, fi);
        var fs = Math.min(L.fs, maxW / per);
        t = el('text', { x: cx.toFixed(1), y: L.y, 'text-anchor': 'middle', 'font-size': fs.toFixed(1), 'font-family': mode === 'prod' ? pf : fi.css, 'font-style': fi.style, 'font-weight': fi.weight, 'data-font': pf, fill: fill });
      }
      t.textContent = txt; (sep && !L.h ? lineHost(i) : g).appendChild(t);
    });
    applyOffset(gC, d.o && d.o.c, W, H);
    lineGs.forEach(function (x) { applyOffset(x[0], d.o && d.o['l' + x[1]], W, H); });
    // los verschuifbare uitsparing (L.kr) over regels met L.km, ook als die apart verschoven zijn
    if (koLines.length && lineGs.length) {
      var tr = function (e) { var m = /translate\(([-\d.]+),([-\d.]+)\)/.exec(e.getAttribute('transform') || ''); return m ? [+m[1], +m[2]] : [0, 0]; };
      var grp = function (i) { for (var q = 0; q < lineGs.length; q++) if (lineGs[q][1] === i) return lineGs[q][0]; return null; };
      if (mode === 'prod') {
        // wit vlak + strepen bovenop de andere regels
        koLines.forEach(function (i) { var og = grp(i); if (og) svg.appendChild(og); });
      } else {
        var T = g.getAttribute('transform'), dfs = el('defs', {}); svg.insertBefore(dfs, svg.firstChild);
        lineGs.forEach(function (x) {
          if (!tpl.lines[x[1]].km) return;
          var ol = tr(x[0]), id = 'gokm' + Math.random().toString(36).slice(2, 8);
          var mk = el('mask', { id: id, maskUnits: 'userSpaceOnUse', x: -2 * W, y: -2 * H, width: 5 * W, height: 5 * H });
          mk.appendChild(el('rect', { x: -2 * W, y: -2 * H, width: 5 * W, height: 5 * H, fill: '#fff' }));
          koLines.forEach(function (i) {
            var og = grp(i); if (!og || !og.querySelector('text,path')) return;
            var oj = tr(og), w = el('g', { transform: 'translate(' + (oj[0] - ol[0]).toFixed(2) + ',' + (oj[1] - ol[1]).toFixed(2) + ') ' + T });
            w.appendChild(el('path', { d: tpl.lines[i].kr, fill: '#000' })); mk.appendChild(w);
          });
          dfs.appendChild(mk); x[0].setAttribute('mask', 'url(#' + id + ')');
        });
      }
    }
  }

  async function render(svg, d, cfg, mode) {
    var W = cfg.W, H = cfg.H;
    var fill = mode === 'prod' ? '#000000' : (cfg.previewFill || 'rgba(255,255,255,0.93)');
    var tok = {}; svg._goTok = tok;
    if (d.tpl) return renderTpl(svg, d, cfg, mode, fill, tok);
    var f = fontInfo(d.f), f2 = d.f2 ? fontInfo(d.f2) : f;
    if (document.fonts && document.fonts.load) {
      try { await document.fonts.load(f.style + ' ' + f.weight + ' 20px ' + f.css, (d.t1 || '') + (d.t2 || '') + 'Ab'); } catch (e) {}
      if (f2 !== f) { try { await document.fonts.load(f2.style + ' ' + f2.weight + ' 20px ' + f2.css, (d.t2 || '') + 'Ab'); } catch (e) {} }
    }
    var meta = d.c && cfg.clips[d.c] ? cfg.clips[d.c] : (d.c === 'logo' ? { logo: true, label: 'Eigen logo' } : null);
    if (meta && meta.logo) meta = { logo: true, label: meta.label, url: meta.url, ratio: d.lr || meta.ratio || 1 };
    var clip = meta ? (meta.logo ? { logo: true } : await loadClip(meta.url)) : null;
    if (svg._goTok !== tok) return; // er is intussen een nieuwere weergave gestart
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    var t1 = (d.t1 || '').trim(), t2 = (d.t2 || '').trim();
    var m1 = sizeF(d.s, 0), mc = sizeF(d.s, 1), m2 = sizeF(d.s, 2);
    var o = d.o || {};
    var gA = null, gB = null, gC = null;

    if (clip && meta.kader) {
      // afbeelding is een kader: tekst binnenin (tekst schuift mee met het kader)
      var r = meta.ratio, cw = W, ch = W / r;
      if (ch > H) { ch = H; cw = H * r; }
      cw *= mc; ch *= mc;
      var cx0 = (W - cw) / 2, cy0 = (H - ch) / 2;
      gC = group(svg, 'c');
      addClip(gC, clip, cx0, cy0, cw, ch, fill);
      var ins = meta.inner || [0.22, 0.3, 0.56, 0.38];
      var ix = cx0 + ins[0] * cw, iy = cy0 + ins[1] * ch, iw = ins[2] * cw, ih = ins[3] * ch;
      applyOffset(gC, o.c, W, H);
      if (t1 && t2) {
        gA = group(gC, 'a'); addText(gA, t1, f, ix + iw / 2, iy + ih * 0.33, iw * Math.min(1, m1 / 0.8), ih * 0.55 * m1 / 0.8, mode, fill);
        gB = group(gC, 'b'); addText(gB, t2, f2, ix + iw / 2, iy + ih * 0.8, iw * 0.85 * Math.min(1, m2 / 0.8), ih * 0.3 * m2 / 0.8, mode, fill);
      } else if (t1 || t2) {
        var mm = t1 ? m1 : m2;
        var gx = group(gC, t1 ? 'a' : 'b'); addText(gx, t1 || t2, t1 ? f : f2, ix + iw / 2, iy + ih / 2, iw * Math.min(1, mm / 0.8), ih * 0.6 * mm / 0.8, mode, fill);
        if (t1) gA = gx; else gB = gx;
      }
      applyOffset(gA, o.a, W, H); applyOffset(gB, o.b, W, H);
      return;
    }

    var gap = H * 0.04;
    var h1 = 0, h2 = 0, hc = 0;
    if (clip) {
      h1 = t1 ? H * 0.22 : 0; h2 = t2 ? H * 0.15 : 0;
      hc = H - h1 - h2 - gap * ((t1 ? 1 : 0) + (t2 ? 1 : 0));
    } else {
      if (t1 && t2) { h1 = H * 0.34; h2 = H * 0.22; } else { h1 = t1 ? H * 0.42 : 0; h2 = t2 ? H * 0.42 : 0; }
    }
    h1 *= m1; h2 *= m2; hc *= mc;
    var cwid = 0, chei = 0, r2 = clip ? meta.ratio : 1;
    if (clip) { chei = hc; cwid = chei * r2; if (cwid > W * 0.94) { cwid = W * 0.94; chei = cwid / r2; } }
    var gaps = gap * ((t1 && (clip || t2) ? 1 : 0) + (t2 && clip ? 1 : 0));
    var sum = h1 + h2 + chei;
    if (sum + gaps > H && sum > 0) { var k = (H - gaps) / sum; h1 *= k; h2 *= k; chei *= k; cwid = chei * r2; }
    var total = h1 + h2 + chei + gaps;
    var y = (H - total) / 2;
    if (t1) { gA = group(svg, 'a'); addText(gA, t1, f, W / 2, y + h1 / 2, W * 0.96, h1, mode, fill); y += h1 + ((clip || t2) ? gap : 0); }
    if (clip) { gC = group(svg, 'c'); if (clip.logo) addLogo(gC, meta, (W - cwid) / 2, y, cwid, chei, mode, fill); else addClip(gC, clip, (W - cwid) / 2, y, cwid, chei, fill); y += chei + (t2 ? gap : 0); }
    if (t2) { gB = group(svg, 'b'); addText(gB, t2, f2, W / 2, y + h2 / 2, W * 0.9, h2, mode, fill); }
    applyOffset(gA, o.a, W, H); applyOffset(gC, o.c, W, H); applyOffset(gB, o.b, W, H);
  }

  function encode(d) {
    var s = JSON.stringify(d);
    return btoa(unescape(encodeURIComponent(s))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function decode(code) {
    code = code.replace(/-/g, '+').replace(/_/g, '/'); while (code.length % 4) code += '=';
    return JSON.parse(decodeURIComponent(escape(atob(code))));
  }

  function productionSVG(svg, d, cfg) {
    var clone = svg.cloneNode(true);
    ['style', 'id', 'class'].forEach(function (a) { clone.removeAttribute(a); });
    Array.prototype.slice.call(clone.attributes).forEach(function (a) { if (/^data-/.test(a.name)) clone.removeAttribute(a.name); });
    clone.querySelectorAll('text').forEach(function (t) {
      t.setAttribute('font-family', t.getAttribute('data-font') || t.getAttribute('font-family'));
      t.setAttribute('font-style', 'normal'); t.setAttribute('font-weight', 'normal'); t.removeAttribute('data-font');
    });
    clone.querySelectorAll('[color]').forEach(function (g) { g.removeAttribute('color'); });
    clone.querySelectorAll('[data-el]').forEach(function (g) { g.removeAttribute('data-el'); });
    clone.setAttribute('xmlns', NS);
    clone.setAttribute('width', cfg.W + 'mm');
    clone.setAttribute('height', cfg.H + 'mm');
    if (d.tpl) {
      var tl = clone.querySelectorAll('text'), parts = [];
      tl.forEach(function (t) { parts.push(t.textContent + ' (' + t.getAttribute('font-family') + ')'); });
      return '<?xml version="1.0" encoding="UTF-8"?>\n<!-- Decorama ontwerp ' + String(d.tpl).toUpperCase() + ' | tekst: ' + (parts.join(' / ') || 'zoals ontwerp') + ' | grootte: ' + ['Klein', 'Normaal', 'Groot', 'Extra groot'][d.s && d.s[1] != null ? d.s[1] : 2] + (d.ls ? ' | regelgrootte: ' + d.ls.map(function (x) { return x == null ? '-' : (LINE_SIZES[x] || LINE_SIZES[1])[0].toLowerCase(); }).join('/') : '') + ' | graveervlak ' + cfg.W + ' x ' + cfg.H + ' mm -->\n' + new XMLSerializer().serializeToString(clone).replace(/currentColor/g, '#000000');
    }
    var head = '<?xml version="1.0" encoding="UTF-8"?>\n<!-- Decorama ontwerp | lettertype: ' + (d.f || '') + (d.f2 ? ' (tekst onder: ' + d.f2 + ')' : '') + ' | tekst boven: ' + (d.t1 || '') + ' | tekst onder: ' + (d.t2 || '') + ' | afbeelding: ' + (d.c || 'geen') + ' | grootte (boven/afb./onder): ' + [0, 1, 2].map(function (i) { return (SIZES[d.s && d.s[i] != null ? d.s[i] : 1] || SIZES[1])[0]; }).join('/') + ' | graveervlak ' + cfg.W + ' x ' + cfg.H + ' mm -->\n';
    return head + new XMLSerializer().serializeToString(clone).replace(/currentColor/g, '#000000');
  }

  function getTpl(cfg, id) { var u = tplUrl(cfg, id); return u ? loadTpl(u) : Promise.resolve(null); }

  window.GlasOntwerper = { FONTS: FONTS, SIZES: SIZES, LINE_SIZES: LINE_SIZES, clampOffset: clampOffset, fontInfo: fontInfo, render: render, encode: encode, decode: decode, productionSVG: productionSVG, getTpl: getTpl, initialOf: initialOf, isDerived: isDerived, keepFont: keepFont, deriveTexts: deriveTexts };
})();
